import { render, staticRenderFns } from "./DoctorReportLorealCard.vue?vue&type=template&id=e23e6f30&scoped=true"
import script from "./DoctorReportLorealCard.vue?vue&type=script&lang=ts"
export * from "./DoctorReportLorealCard.vue?vue&type=script&lang=ts"
import style0 from "./DoctorReportLorealCard.vue?vue&type=style&index=0&id=e23e6f30&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23e6f30",
  null
  
)

export default component.exports